export default "__VITE_ASSET__DdzzliQT__"